"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inDateTimeRange = exports.between = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
/** returns true if x is same or higher that lo, and less than hi */
const between = (x, lo, hi) => {
    return (0, iotv_v3_types_1.isNonNaNNumber)(x) && x >= lo && x < hi;
};
exports.between = between;
const inDateTimeRange = (x, lo, hi) => {
    return x && x >= lo && x < hi;
};
exports.inDateTimeRange = inDateTimeRange;
